var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoPantalla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3459,
    height: 2240,
    viewBox: "0 0 3459 2240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_195)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_74_195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2042,
    height: 2240
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2239.37H2041.38V0.000976562H0V2239.37Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1314.47 1795.34C1070.11 2041.35 764.622 2197.3 455.925 2234.27C410.898 2239.12 365.871 2242.32 320.844 2242.32C66.7879 2242.32 -156.701 2155.47 -320.703 1989.91C-513.631 1795.34 -598.835 1517.21 -563.504 1206.95C-528.172 895.052 -372.142 587.92 -127.779 340.354C153.554 57.3745 515.329 -106.627 865.848 -106.627C989.672 -106.627 1108.65 -85.7565 1216.37 -43.9355C1327.29 -0.550549 1426.96 62.1414 1508.96 145.786C1904.5 546.095 1819.3 1287.31 1314.39 1795.42L1314.47 1795.34ZM592.566 -356.411C-185.459 -356.411 -819.532 282.509 -819.532 1068.59C-819.532 1854.66 -185.459 2492.02 592.566 2492.02C1370.59 2492.02 2004.67 1853.1 2004.67 1068.59C2004.67 284.069 1370.59 -356.411 592.566 -356.411Z",
    fill: "#897E5E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3458.27,
    height: 2239.37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_74_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3458.27,
    height: 2239.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoPantalla);
export default __webpack_public_path__ + "static/media/fondo_pantalla.726005afd26fd2249f7f1be32f95224c.svg";
export { ForwardRef as ReactComponent };